import { skillsList } from "@/redux/features/candidateProfileSlice";
import { z } from "zod";

const schema = z.object({
  topSkills: z.enum(skillsList).array().optional(),
  secondarySkills: z.enum(skillsList).array().optional(),
  additionalSkills: z.enum(skillsList).array().optional(),
});

type Schema = z.infer<typeof schema>;

export {
  schema as candidateSkillFormSchema,
  type Schema as CandidateSkillFormSchema,
};
